var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"divider",style:({ border: `solid ${_vm.thickness}px  ${_vm.color}` })},'div',_vm.$attrs,false))
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }